import { render, staticRenderFns } from "./ExternalDamageLocalization.vue?vue&type=template&id=bdcadab8&scoped=true"
import script from "./ExternalDamageLocalization.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageLocalization.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamageLocalization.vue?vue&type=style&index=0&id=bdcadab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcadab8",
  null
  
)

export default component.exports